var map = {
	"./airdrop.js": 28913,
	"./assets.js": 24863,
	"./autobot.js": 54855,
	"./daily.js": 51572,
	"./lottery.js": 43136,
	"./mine.js": 40821,
	"./ranking.js": 51734,
	"./squad.js": 20849,
	"./task.js": 72390,
	"./user.js": 69220,
	"./wallet.js": 9944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80095;